// extracted by mini-css-extract-plugin
module.exports = {"demi-bold":"Checkbox_demi-bold__qoVYw","label":"Checkbox_label__CbFqD","checkboxContainer":"Checkbox_checkboxContainer__RNxPR","fadeInAnimation":"Checkbox_fadeInAnimation__kkniV"};